import createEndpoint from '~/api/createEndpoint';

const signOut = createEndpoint<'POST', Record<string, never>, Record<string, never>>({ path: '/auth/sign-out/global/' });

export default signOut;
